<!--
 * @Author: p_fy
 * @Date: 2019-06-19 16:02:51
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 18:27:31
 * @Description: 仓库需求发布页面，页面：普仓、罐区
 -->
<template>
  <div>
    <div class="main-wrap">
      <div style="padding-top: 10px;" class="menu-head">
        <div style="width: 100%;">
          <el-tabs v-model="activeName" v-loading="loading" @tab-click="handleClick">
            <el-tab-pane label="普仓需求发布" name="first">
              <div class="first-error">
                <div id="container" style="width:100px;height: 100px;display: none;" />
                <div id="panel" />
                <el-form
                  ref="storageDemand"
                  :rules="storageDemandRules"
                  :model="storageDemand"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="租单名称" prop="demandName">
                        <el-input v-model.trim="storageDemand.demandName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物类型" prop="storageType">
                        <el-checkbox-group v-model="storageDemand.storageType" @change="handleCheckedCitiesChange">
                          <el-checkbox v-for="city in storageType.storageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="起租日期" prop="leaseStartTime">
                        <el-date-picker
                          v-model="datepicker"
                          type="daterange"
                          :editable="false"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions"
                          style="width:100%"
                          @change="dateSet"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="期望租金" prop="expectPrice">
                        <el-input v-model.trim="storageDemand.expectPrice">
                          <template slot="append">元/m²/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                      <el-form-item label="起租日期" prop="leaseStartTime">
                        <el-date-picker v-model="storageDemand.leaseStartTime" type="date" placeholder="选择日期" style="width: 100%;" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <span style="position: absolute;margin-left: 2rem;margin-top: 0.3rem;">———</span>
                      <el-form-item prop="leaseEndTime">
                        <el-date-picker v-model="storageDemand.leaseEndTime" type="date" placeholder="选择日期" style="width: 100%;" />
                      </el-form-item>
                    </el-col> -->
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="仓库类型" prop="warehouseType">
                        <el-select v-model="storageDemand.warehouseType" warehouse-type="请选择">
                          <el-option v-for="city in storageType.warehouseType" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="需求面积" prop="demandArea">
                        <el-input v-model.trim="storageDemand.demandArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          v-model="storageDemand.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="storageDemand.fireQualification" placeholder="请选择消防资质">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库内设备" prop="warehouseEquipment">
                        <el-select v-model="storageDemand.warehouseEquipment" multiple placeholder="请选择">
                          <el-option v-for="city in storageType.storeEquipment" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地坪质地" prop="floorTexture">
                        <el-select v-model="storageDemand.floorTexture" placeholder="请选择地坪质地">
                          <el-option v-for="city in storageType.floorTexture" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="卸货平台" prop="landingPlatform">
                        <el-select v-model="storageDemand.landingPlatform" placeholder="请选择卸货平台">
                          <el-option v-for="city in storageType.landingPlatform" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物照片" prop="cargoUrl">
                        <g-upload :max-size="1" :limit="6" is-edit :method-name="authenticationFile" :multiple="true" :img-list.sync="storageDemand.cargoUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="storageDemand.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="storageDemand.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="storageDemand.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="备注" prop="remarks">
                        <el-input v-model="storageDemand.remarks" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" size="small" @click="storageDemandSave('storageDemand',2)">发布</el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="普仓需求保存" name="sencond">
              <div class="sencond-error">
                <div id="container" style="width:100px;height: 100px;display: none;" />
                <div id="panel" />
                <el-form
                  ref="storageDemandNoRequire"
                  :rules="storageDemandNoRequireRules"
                  :model="storageDemand"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="租单名称" prop="demandName">
                        <el-input v-model="storageDemand.demandName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物类型" prop="storageType">
                        <el-checkbox-group v-model="storageDemand.storageType" @change="handleCheckedCitiesChange">
                          <el-checkbox v-for="city in storageType.storageType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="起租日期" prop="leaseStartTime">
                        <el-date-picker
                          v-model="datepicker"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          :editable="false"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions"
                          style="width:100%"
                          @change="dateSet"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="期望租金" prop="expectPrice">
                        <el-input v-model="storageDemand.expectPrice">
                          <template slot="append">元/m²/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="仓库类型" prop="warehouseType">
                        <el-select v-model="storageDemand.warehouseType" warehouse-type="请选择">
                          <el-option v-for="city in storageType.warehouseType" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="需求面积" prop="demandArea">
                        <el-input v-model="storageDemand.demandArea">
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          v-model="storageDemand.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="storageDemand.fireQualification" placeholder="请选择消防资质">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="库内设备" prop="warehouseEquipment">
                        <el-select v-model="storageDemand.warehouseEquipment" multiple placeholder="请选择">
                          <el-option v-for="city in storageType.storeEquipment" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="地坪质地" prop="floorTexture">
                        <el-select v-model="storageDemand.floorTexture" placeholder="请选择地坪质地">
                          <el-option v-for="city in storageType.floorTexture" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="卸货平台" prop="landingPlatform">
                        <el-select v-model="storageDemand.landingPlatform" placeholder="请选择消防资质">
                          <el-option v-for="city in storageType.landingPlatform" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物照片" prop="cargoUrl">
                        <g-upload :max-size="1" :limit="6" is-edit :method-name="authenticationFile" :multiple="true" :img-list.sync="storageDemand.cargoUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="storageDemand.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="storageDemand.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="storageDemand.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="备注" prop="remarks">
                        <el-input v-model="storageDemand.remarks" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" plain size="small" @click="storageDemandSave('storageDemandNoRequire',1)">保存</el-button>
                  </div>
                </el-form>
              </div>
            </el-tab-pane>

            <el-tab-pane label="罐区需求发布" name="third"><div>
              <div class="third-error">
                <el-form
                  ref="tankFarmDemand"
                  :rules="tankFarmDemandRules"
                  :model="tankFarmDemand"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="租单名称" prop="demandName">
                        <el-input v-model.trim="tankFarmDemand.demandName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物类型" prop="storageType">
                        <el-checkbox-group v-model="tankFarmDemand.storageType">
                          <el-checkbox v-for="city in storageType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="预租时间" prop="leaseStartTime">
                        <el-date-picker
                          v-model="tankdatepicker"
                          type="daterange"
                          :editable="false"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions"
                          style="width:100%"
                          @change="tankDateSet"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="期望价格" prop="expectPrice">
                        <el-input v-model.trim="tankFarmDemand.expectPrice">
                          <template slot="append">元/罐/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                      <el-form-item label="预租时间" prop="leaseStartTime">
                        <el-date-picker v-model="tankFarmDemand.leaseStartTime" type="date" placeholder="选择日期" style="width: 100%;" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <span style="position: absolute;margin-left: 2rem;margin-top: 0.3rem;">———</span>
                      <el-form-item prop="leaseEndTime">
                        <el-date-picker v-model="tankFarmDemand.leaseEndTime" type="date" placeholder="选择日期" style="width: 100%;" />
                      </el-form-item>
                    </el-col> -->
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="货物容积" prop="goodsCubage">
                        <el-input v-model.trim="tankFarmDemand.goodsCubage">
                          <template slot="append">m³</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          v-model="tankFarmDemand.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="tankFarmDemand.fireQualification" placeholder="请选择">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="罐区耐火等级" prop="fireResistanceRating">
                        <el-select v-model="tankFarmDemand.fireResistanceRating" placeholder="请选择罐区耐火等级">
                          <el-option v-for="city in storageType.fireResistanceRating" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物图片" prop="cargoUrl">
                        <g-upload :limit="6" is-edit :max-size="1" :multiple="true" :method-name="authenticationFile" :img-list.sync="tankFarmDemand.cargoUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="tankFarmDemand.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="tankFarmDemand.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="tankFarmDemand.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="备注" prop="remarks">
                        <el-input v-model="tankFarmDemand.remarks" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" size="small" @click="tankFarmDemandSave('tankFarmDemand',2)">发布</el-button>
                  </div>
                </el-form>
              </div>
            </div>
            </el-tab-pane>
            <el-tab-pane label="罐区需求保存" name="fourth"><div>
              <div class="fourth-error">
                <el-form
                  ref="tankFarmDemandNoRequire"
                  :rules="tankFarmDemandNoRequireRules"
                  :model="tankFarmDemand"
                  :label-position="'right'"
                  label-width="120px"
                  style="padding-left: 0rem;padding-right: 2rem;"
                >
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="租单名称" prop="demandName">
                        <el-input v-model="tankFarmDemand.demandName" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物类型" prop="storageType">
                        <el-checkbox-group v-model="tankFarmDemand.storageType">
                          <el-checkbox v-for="city in storageType.tankType" :key="city.label" :label="city.value">{{ city.label }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="预租时间" prop="leaseStartTime">
                        <el-date-picker
                          v-model="tankdatepicker"
                          :editable="false"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions"
                          style="width:100%"
                          @change="tankDateSet"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="期望价格" prop="expectPrice">
                        <el-input v-model="tankFarmDemand.expectPrice">
                          <template slot="append">元/罐/天</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="货物容积" prop="goodsCubage">
                        <el-input v-model="tankFarmDemand.goodsCubage">
                          <template slot="append">m³</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="库房位置" prop="storageLocation">
                        <el-cascader
                          v-model="tankFarmDemand.storageLocation"
                          :options="area"
                          :filterable="true"
                          :props="{ expandTrigger: 'hover' ,
                                    checkStrictly: true}"
                          style="width: 100%;"
                          @expand-change="expandChange"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="消防资质" prop="fireQualification">
                        <el-select v-model="tankFarmDemand.fireQualification" placeholder="请选择">
                          <el-option v-for="city in storageType.fireQualification" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="罐区耐火等级" prop="fireResistanceRating">
                        <el-select v-model="tankFarmDemand.fireResistanceRating" placeholder="请选择消防资质">
                          <el-option v-for="city in storageType.fireResistanceRating" :key="city.label" :label="city.label" :value="city.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="货物图片" prop="cargoUrl">
                        <g-upload :limit="6" is-edit :max-size="1" :multiple="true" :method-name="authenticationFile" :img-list.sync="tankFarmDemand.cargoUrl" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="" style="color: #606266;">
                        上传格式.jpg/.png文件，建议尺寸1920*700，且大小不超过1M
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="公司名称" prop="companyName">
                        <el-input v-model="tankFarmDemand.companyName" :disabled="true" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="12">
                      <el-form-item label="联系人" prop="linkMan">
                        <el-input v-model="tankFarmDemand.linkMan" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号" prop="telephone">
                        <el-input v-model="tankFarmDemand.telephone" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="备注" prop="remarks">
                        <el-input v-model="tankFarmDemand.remarks" type="textarea" :rows="6" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="">
                        <span style="color: #be2316;">注：</span>
                        <span>*均为必填项</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div style="text-align: center;">
                    <el-button type="danger" plain size="small" @click="tankFarmDemandSave('tankFarmDemandNoRequire',1)">保存</el-button>
                  </div>
                </el-form>
              </div>
            </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
// 引用数据
import { createInfo, createTankFarmInfo, getArea, getDict, getCompanyInfo } from '@/api/personal/store/publish-demand/publishDemand'

import { DatabaseUtil } from '@/utils/databaseUtils'
const dataBase = new DatabaseUtil()
export default {
  name: 'PublishDemand',
  components: {

  },
  data: function() {
    // 需求面积校验方法
    var demandArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入需求面积'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (value != 0 && value.length < 11 && number.reg.test(value)) {
            callback()
          } else {
            callback(new Error(number.title))
          }
        }
      }
    }
    // 期望租金校验方法
    var expectPrice = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        // title: '请输入正确内容(正数不超过10位且小数点最多两位)'
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入期望租金'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (value != 0 && value.length < 11 && number.reg.test(value)) {
            callback()
          } else {
            callback(new Error(number.title))
          }
        }
      }
    }
    // 货物容积校验方法
    var goodsCubage = (rule, value, callback) => {
      const number = {
        reg: /^0{1,11}([.]\d{1,2})?$|^[1-9]\d*([.]{1,11}[0-9]{1,4})?$/,
        // title: '请输入正确内容(正数不超过10位且小数点最多4位)',
        title: '请输入最多10位(数字、小数)且小数点最多4位'
      }
      if (!value) {
        if (Object.keys(rule).some(key => key === 'required') && !rule['required']) {
          return callback()
        }
        return callback(new Error('请输入货物容积'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (value != 0 && value.length < 11 && number.reg.test(value)) {
            callback()
          } else {
            callback(new Error(number.title))
          }
        }
      }
    }
    return {
      imageUrl: '',
      activeName: 'first',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      loading: true,
      post_flag: false,
      checkAll: false,
      isIndeterminate: true,
      authenticationFile: 'cangchuFile',
      area: [],
      datepicker: null,
      tankdatepicker: null,
      storageType: {
        storageType: [],
        warehouseType: [],
        fireQualification: [],
        storeEquipment: [],
        floorTexture: [],
        landingPlatform: [],
        fireResistanceRating: [],
        tankType: []
      },
      storageDemand: {
        demandName: null, // 租单名称
        warehouseType: null, // 仓库类型
        storageType: [], // 储存类型
        demandArea: null, // 需求面积
        leaseStartTime: null, // 租赁开始日期
        leaseEndTime: null, // 租赁结束日期
        expectPrice: null, // 期望租金
        storageLocation: null, // 库房位置
        fireQualification: null, // 消防资质
        floorTexture: null, // 地坪质地
        warehouseEquipment: null, // 库内设备
        landingPlatform: null, // 卸货平台
        companyId: null, // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageRecommend: null, // 仓库简介
        remarks: null, // 备注
        cargoUrl: '', // 货物照片
        publishStatus: null // 发布状态 1待发布 2已发布
      },
      tankFarmDemand: {
        demandName: null, // 需求名称
        storageType: [], // 储存类型
        leaseStartTime: null, // 租赁开始日期
        leaseEndTime: null, // 租赁结束日期
        goodsCubage: null, // 货物容积
        expectPrice: null, // 期望价格
        companyId: null, // 公司id
        companyName: null, // 公司名称
        storageLocation: null, // 库房位置
        fireQualification: null, // 消防资质
        fireResistanceRating: null, // 罐区耐火等级
        cargoUrl: '', // 货物照片
        remarks: null, // 备注
        linkMan: null, // 联系人
        telephone: null, // 手机号
        publishStatus: null // 发布状态  1待发布 2已发布
      }, // 定义弹框对象
      storageDemandNoRequireRules: {
        demandName: [{ required: false, validator: this.$character(1, 50, 'checkEmpty'), trigger: 'blur' }], // 租单名称
        demandArea: [{ required: false, validator: demandArea }], // 需求面积
        expectPrice: [{ required: false, validator: expectPrice }], // 期望租金
        linkMan: [{ required: false, validator: this.$character(1, 20, 'checkEmpty'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        storageRecommend: [{ required: false, validator: this.$character(2, 200, 'checkEmpty'), trigger: 'blur' }], // 仓库简介
        remarks: [{ required: false, validator: this.$character(1, 200, 'checkEmpty'), trigger: 'blur' }] // 备注
        // cargoUrl: [{ required: true, message: '请输入货物照片', trigger: 'blur' }] // 货物照片
      },
      storageDemandRules: {
        demandName: [{ required: true, validator: this.$character(1, 50, 'check'), trigger: 'blur' }], // 租单名称
        warehouseType: [{ required: true, message: '请选择仓库类型', trigger: 'change' }], // 仓库类型
        storageType: [{ type: 'array', required: true, message: '请至少选择一个货物类型', trigger: 'change' }], // 储存类型
        demandArea: [{ required: true, validator: demandArea }], // 需求面积
        leaseStartTime: [{ required: true, message: '请选择起租日期', trigger: 'change' }], // 租赁开始日期
        leaseEndTime: [{ required: true, message: '请选择结束日期', trigger: 'change' }], // 租赁结束日期
        expectPrice: [{ required: true, validator: expectPrice }], // 期望租金
        storageLocation: [{ required: true, message: '请选择库房位置', trigger: 'change' }], // 库房位置
        fireQualification: [{ required: true, message: '请选择消防资质', trigger: 'change' }], // 消防资质
        floorTexture: [{ required: true, message: '请选择地坪质地', trigger: 'change' }], // 地坪质地
        warehouseEquipment: [{ required: true, message: '请选择库内设备', trigger: 'blur' }], // 库内设备
        landingPlatform: [{ required: true, message: '请选择卸货平台', trigger: 'change' }], // 卸货平台
        companyName: [{ required: true, message: '未认证、请先认证个人信息', trigger: 'blur' }], // 公司名称
        linkMan: [{ required: true, validator: this.$character(1, 20, 'check'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        storageRecommend: [{ required: true, validator: this.$character(2, 200, 'checkEmpty'), trigger: 'blur' }], // 仓库简介
        remarks: [{ required: false, validator: this.$character(1, 200, 'checkEmpty'), trigger: 'blur' }] // 备注
        // cargoUrl: [{ required: true, message: '请输入货物照片', trigger: 'blur' }] // 货物照片
      },
      tankFarmDemandNoRequireRules: {
        demandName: [{ required: false, validator: this.$character(1, 50, 'checkEmpty'), trigger: 'blur' }], // 需求名称
        goodsCubage: [{ required: false, validator: goodsCubage }], // 货物容积
        expectPrice: [{ required: false, validator: expectPrice }], // 期望价格
        linkMan: [{ required: false, validator: this.$character(2, 20, 'checkEmpty'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        remarks: [{ required: false, validator: this.$character(1, 200, 'checkEmpty'), trigger: 'blur' }] // 备注
      },
      tankFarmDemandRules: {
        demandName: [{ required: true, validator: this.$character(1, 50, 'check'), trigger: 'blur' }], // 需求名称
        storageType: [{ type: 'array', required: true, message: '请至少选择一个货物类型', trigger: 'change' }], // 储存类型
        leaseStartTime: [{ required: true, message: '请选择预租日期', trigger: 'change' }], // 租赁开始日期
        leaseEndTime: [{ required: true, message: '请选择结束日期', trigger: 'change' }], // 租赁结束日期
        goodsCubage: [{ required: true, validator: goodsCubage }], // 货物容积
        expectPrice: [{ required: true, validator: expectPrice }], // 期望价格
        companyName: [{ required: true, message: '未认证、请先认证个人信息', trigger: 'blur' }], // 公司名称
        storageLocation: [{ required: true, message: '请选择库房位置', trigger: 'change' }], // 库房位置
        fireQualification: [{ required: true, message: '请选择消防资质', trigger: 'change' }], // 消防资质
        fireResistanceRating: [{ required: true, message: '请选择罐区耐火等级', trigger: 'change' }], // 罐区耐火等级
        // cargoUrl: [{ required: true, message: '请输入货物照片', trigger: 'blur' }], // 货物照片
        linkMan: [{ required: true, validator: this.$character(1, 20, 'check'), trigger: 'blur' }], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        remarks: [{ required: false, validator: this.$character(1, 200, 'checkEmpty'), trigger: 'blur' }] // 备注
      },
      map: null
    }
  },
  // 初始化加载 所有资格认证数据
  created() {
    (async() => {
      await this.getArea()
      await this.getStorageType()
      await this.getWarehouseType()
      await this.getFireQualification()
      await this.getStoreEquipment()
      await this.getFloorTexture()
      await this.getLandingPlatform()
      await this.getFireResistanceRating()
      await this.getTankType()
      await this.getCompanyInfo()
      this.loading = false
    })()
  },
  mounted() {

  },
  methods: {
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 重置菜单
    deldemand() {
      this.storageDemand = {
        demandName: null, // 租单名称
        warehouseType: null, // 仓库类型
        storageType: [], // 储存类型
        demandArea: null, // 需求面积
        leaseStartTime: null, // 租赁开始日期
        leaseEndTime: null, // 租赁结束日期
        expectPrice: null, // 期望租金
        storageLocation: null, // 库房位置
        fireQualification: null, // 消防资质
        floorTexture: null, // 地坪质地
        warehouseEquipment: null, // 库内设备
        landingPlatform: null, // 卸货平台
        companyId: null, // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageRecommend: null, // 仓库简介
        remarks: null, // 备注
        cargoUrl: '', // 货物照片
        publishStatus: null // 发布状态 1待发布 2已发布
      }
      this.tankFarmDemand = {
        demandName: null, // 需求名称
        storageType: [], // 储存类型
        leaseStartTime: null, // 租赁开始日期
        leaseEndTime: null, // 租赁结束日期
        goodsCubage: null, // 货物容积
        expectPrice: null, // 期望价格
        companyId: null, // 公司id
        companyName: null, // 公司名称
        storageLocation: null, // 库房位置
        fireQualification: null, // 消防资质
        fireResistanceRating: null, // 罐区耐火等级
        cargoUrl: '', // 货物照片
        remarks: null, // 备注
        linkMan: null, // 联系人
        telephone: null, // 手机号
        publishStatus: null // 发布状态  1待发布 2已发布
      }
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
        console.log('执行了')
      }, 100)
    },
    // 普仓需求日期回调
    dateSet(date) {
      if (date == null) {
        return false
      }
      this.storageDemand.leaseStartTime = date[0] // 租赁开始日期
      this.storageDemand.leaseEndTime = date[1] // 租赁结束日期
    },
    // 罐区需求日期回调
    tankDateSet(date) {
      if (date == null) {
        return false
      }
      this.tankFarmDemand.leaseStartTime = date[0] // 租赁开始日期
      this.tankFarmDemand.leaseEndTime = date[1] // 租赁结束日期
    },
    // 查询企业信息
    getCompanyInfo() {
      getCompanyInfo()
        .then(data => {
          // this.storageDemand.linkMan = data.user.userName
          // this.storageDemand.telephone = data.user.phone
          this.storageDemand.companyId = data.user.id
          this.storageDemand.companyName = data.user.companyName
          // this.tankFarmDemand.linkMan = data.user.userName
          // this.tankFarmDemand.telephone = data.user.phone
          this.tankFarmDemand.companyId = data.user.id
          this.tankFarmDemand.companyName = data.user.companyName
        })
        .catch(error => {
          console.error(error)
        })
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType').then((storageType) => {
        if (storageType.length > 0) {
          storageType.forEach(res => {
            this.storageType.storageType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storageType').then(res => {
          const storageType = JSON.parse(res.result)
          this.setLocalStorageUtil('storageType', storageType)
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 仓库类型字典
    getWarehouseType() {
      this.getLocalStorageUtil('warehouseType').then((warehouseType) => {
        if (warehouseType.length > 0) {
          warehouseType.forEach(res => {
            this.storageType.warehouseType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('warehouseType').then(res => {
          const warehouseType = JSON.parse(res.result)
          this.setLocalStorageUtil('warehouseType', warehouseType)
          if (warehouseType.length > 0) {
            warehouseType.forEach(res => {
              this.storageType.warehouseType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 消防资质字典
    getFireQualification() {
      this.getLocalStorageUtil('fireQualification').then((fireQualification) => {
        if (fireQualification.length > 0) {
          fireQualification.forEach(res => {
            this.storageType.fireQualification.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireQualification').then(res => {
          const fireQualification = JSON.parse(res.result)
          this.setLocalStorageUtil('fireQualification', fireQualification)
          if (fireQualification.length > 0) {
            fireQualification.forEach(res => {
              this.storageType.fireQualification.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 库内设备字典
    getStoreEquipment() {
      this.getLocalStorageUtil('storeEquipment').then((storeEquipment) => {
        if (storeEquipment.length > 0) {
          storeEquipment.forEach(res => {
            this.storageType.storeEquipment.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('storeEquipment').then(res => {
          const storeEquipment = JSON.parse(res.result)
          this.setLocalStorageUtil('storeEquipment', storeEquipment)
          if (storeEquipment.length > 0) {
            storeEquipment.forEach(res => {
              this.storageType.storeEquipment.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 地坪质地字典
    getFloorTexture() {
      this.getLocalStorageUtil('floorTexture').then((floorTexture) => {
        if (floorTexture.length > 0) {
          floorTexture.forEach(res => {
            this.storageType.floorTexture.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('floorTexture').then(res => {
          const floorTexture = JSON.parse(res.result)
          this.setLocalStorageUtil('floorTexture', floorTexture)
          if (floorTexture.length > 0) {
            floorTexture.forEach(res => {
              this.storageType.floorTexture.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 卸货平台字典
    getLandingPlatform() {
      this.getLocalStorageUtil('landingPlatform').then((landingPlatform) => {
        if (landingPlatform.length > 0) {
          landingPlatform.forEach(res => {
            this.storageType.landingPlatform.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('landingPlatform').then(res => {
          const landingPlatform = JSON.parse(res.result)
          this.setLocalStorageUtil('landingPlatform', landingPlatform)
          if (landingPlatform.length > 0) {
            landingPlatform.forEach(res => {
              this.storageType.landingPlatform.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区耐火等级字典
    getFireResistanceRating() {
      this.getLocalStorageUtil('fireResistanceRating').then((fireResistanceRating) => {
        if (fireResistanceRating.length > 0) {
          fireResistanceRating.forEach(res => {
            this.storageType.fireResistanceRating.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('fireResistanceRating').then(res => {
          const fireResistanceRating = JSON.parse(res.result)
          this.setLocalStorageUtil('fireResistanceRating', fireResistanceRating)
          if (fireResistanceRating.length > 0) {
            fireResistanceRating.forEach(res => {
              this.storageType.fireResistanceRating.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    // 罐区储存类型字典
    getTankType() {
      this.getLocalStorageUtil('tankType').then((tankType) => {
        if (tankType.length > 0) {
          tankType.forEach(res => {
            this.storageType.tankType.push({
              label: res.label,
              value: res.value
            })
          })
        }
      }).catch(() => {
        getDict('tankType').then(res => {
          const tankType = JSON.parse(res.result)
          this.setLocalStorageUtil('tankType', tankType)
          if (tankType.length > 0) {
            tankType.forEach(res => {
              this.storageType.tankType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(err => {
          console.error(err)
        })
      })
    },
    storageDemandSave(rulesForm, status) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const demand = JSON.parse(JSON.stringify(this.storageDemand))
          demand.publishStatus = status
          if (this.storageDemand) {
            if (this.storageDemand.storageLocation && Object.prototype.toString.call(this.storageDemand.storageLocation).indexOf('Array') !== -1 && this.storageDemand.storageLocation.length > 0) {
              demand.storageLocation = this.storageDemand.storageLocation.join('#')
            } else {
              demand.storageLocation = ''
            }

            if (this.storageDemand.storageType) {
              demand.storageType = this.storageDemand.storageType.join(',')
            } else {
              demand.storageType = ''
            }
            if (this.storageDemand.warehouseEquipment) {
              demand.warehouseEquipment = this.storageDemand.warehouseEquipment.join(',')
            } else {
              demand.warehouseEquipment = ''
            }
          }
          createInfo(demand).then((result) => {
            // 成功提示
            this.$message({
              showClose: true,
              offset: 100,
              message: status == '1' ? '普仓信息，保存成功' : '普仓信息，发布成功',
              type: 'success'
            })
            this.post_flag = false
            this.deldemand()
            this.$router.push({ name: 'StoreDemandList' })
          }).catch((err) => {
            console.log(err)
            this.post_flag = false
          })
        } else {
          // 失败返回数据
          setTimeout(() => {
            var isError = document.getElementsByClassName(`${this.activeName}-error`)[0].getElementsByClassName('is-error')
            if (isError[0].querySelector('input').type == 'file') {
              isError[0].querySelector('input').style.display = 'block'
              isError[0].querySelector('input').focus()
              isError[0].querySelector('input').style.display = 'none'
            } else {
              isError[0].querySelector('input').focus()
            }
          }, 1)
          return false
        }
      })
    },
    tankFarmDemandSave(rulesForm, status) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            // console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const demand = JSON.parse(JSON.stringify(this.tankFarmDemand))
          demand.publishStatus = status
          if (this.tankFarmDemand) {
            if (this.tankFarmDemand.storageLocation && Object.prototype.toString.call(this.tankFarmDemand.storageLocation).indexOf('Array') !== -1 && this.tankFarmDemand.storageLocation.length > 0) {
              demand.storageLocation = this.tankFarmDemand.storageLocation.join('#')
            } else {
              demand.storageLocation = ''
            }
            if (this.tankFarmDemand.storageType) {
              demand.storageType = this.tankFarmDemand.storageType.join(',')
            } else {
              demand.storageType = ''
            }
          }
          createTankFarmInfo(demand).then((result) => {
            // 成功提示
            this.$message({
              showClose: true,
              offset: 100,
              message: status == '1' ? '罐区信息，保存成功' : '罐区信息，发布成功',
              type: 'success'
            })
            this.post_flag = false
            this.deldemand()
            this.$router.push({ name: 'TankDemandList' })
          }).catch((err) => {
            console.log(err)
            this.post_flag = false
          })
        } else {
          // 失败返回数据
          setTimeout(() => {
            var isError = document.getElementsByClassName(`${this.activeName}-error`)[0].getElementsByClassName('is-error')
            if (isError[0].querySelector('input').type == 'file') {
              isError[0].querySelector('input').style.display = 'block'
              isError[0].querySelector('input').focus()
              isError[0].querySelector('input').style.display = 'none'
            } else {
              isError[0].querySelector('input').focus()
            }
          }, 1)
          return false
        }
      })
    },
    // 菜单切换监听
    handleClick(tab, event) {
      console.log(tab, event)
    },
    // 分页监听
    handleCheckAllChange(val) {
      const cityOptionsList = []
      this.storageType.storageType.forEach(res => {
        cityOptionsList.push(res.lable)
      })
      this.storageDemand.storageType = val ? cityOptionsList : []
      this.isIndeterminate = false
    },
    // 分页监听
    handleCheckedCitiesChange(value) {
      const cityOptionsList = []
      this.storageType.storageType.forEach(res => {
        cityOptionsList.push(res.lable)
      })
      const checkedCount = value.length
      this.checkAll = checkedCount === cityOptionsList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < cityOptionsList.length
    }
  }
}
</script>
<style scoped lang='scss'>
  @import "@/styles/standardColor.scss";
  .my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
  /deep/.el-input-group__append, .el-input-group__prepend {
      background-color: #ffffff;
      color: #909399;
      vertical-align: middle;
      display: table-cell;
      position: relative;
      border: 1px solid #DCDFE6;
      border-left: 0;
      border-radius: 0px;
      padding: 0 10px;
      width: 1px;
      white-space: nowrap;
  }

  $prefix: "el-tabs__";
  /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before  {
    content: '*';
    color: #be2316;
    font-size: 16px;
    margin-right: 4px;
  }
  input__inner {
    background-color: white;
    border-radius: 0px;
    border: 0;
    border-bottom: 1px solid gainsboro;
  }
  /deep/.el-input input{
    border-radius:0px;
  }
  /deep/.checkboxSty .el-input .el-input__inner , /deep/.el-textarea .el-textarea__inner{
    border-radius:0px;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  /deep/.checkboxSty{
    width:100%;
  }
  /deep/.sfSty{
    color:#409EFF
  }
  /deep/.sfSty:hover{
    color: #8c939d
  }
  /deep/.el-select{
    width:100%;
  }
  /deep/.el-card .el-card__body{
    display: grid;
    padding: 4rem;
  }
  // #{prefix}
  /deep/.is-active{
    color:#BE2316;
    font-size: 18px;
    font-weight: bold;
  }
  /deep/.el-tabs__item{
    font-size: 18px;
    font-weight: bold;
  }
  /deep/.el-tabs__item:hover {
    color: #BE2316;
    cursor: pointer;
  }
  /deep/.el-tabs__active-bar{
    background-color: #BE2316;
    height: 1px;
  }
  /deep/.el-tabs__nav-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #E4E7ED;
    z-index: 1;
  }
  /deep/.el-form.el-form--label-right .el-form-item__content {
    margin-left: 0rem;
  }
  .el-button-ml{
    margin-left: 35%;
    width: 35%;
    height: 40px;
    margin-top: 50px;
    font-size: 18px;
    background-color: #BE2316;
    margin-bottom: 10%
  }
  .menu-head {
    display: flex;
    margin: 1rem;
    padding-bottom: 1rem;
    border-style: dashed;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    .head-color {
      width: 5px;
      height: 18px;
      background-color: #be2316;
      border-radius: 5px;
      margin-right: 1rem;
    }
    font-size: 18px;
    font-weight: bold;
  }
  .main-wrap{
    width: 100%;
    background-color: white;
    margin-top: -15px;
  }
</style>
